/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Alternatives_Curated_BadgeInputs */

const en_directory_alternatives_curated_badge = /** @type {(inputs: Directory_Alternatives_Curated_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editorial pick`)
};

const zh_directory_alternatives_curated_badge = /** @type {(inputs: Directory_Alternatives_Curated_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑精选`)
};

/**
* | output |
* | --- |
* | "Editorial pick" |
*
* @param {Directory_Alternatives_Curated_BadgeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_alternatives_curated_badge = /** @type {((inputs?: Directory_Alternatives_Curated_BadgeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Alternatives_Curated_BadgeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_alternatives_curated_badge(inputs)
	return zh_directory_alternatives_curated_badge(inputs)
});
export { directory_alternatives_curated_badge as "directory.alternatives.curated_badge" }